module.exports = __webpack_public_path__ + "static/poster-e1ffadc6721ffafd205dcb02cbbbb2df.png";